// Minimal web polyfills for RN libs expecting Node globals
(function () {
  const g = (typeof globalThis !== 'undefined') ? globalThis : (typeof window !== 'undefined' ? window : this);
  if (!g.global) g.global = g;
  if (!g.process) g.process = { env: { NODE_ENV: (typeof __webpack_hash__ !== 'undefined') ? 'development' : 'production' } };
  if (!g.process.env) g.process.env = { NODE_ENV: 'development' };
})();
